import React from 'react';
import { useTranslation } from 'react-i18next';

function SecurityStepUpModal({
  isOpen,
  isSubmitting,
  error,
  onSubmit,
  onCancel,
}) {
  const { t } = useTranslation();
  const [code, setCode] = React.useState('');

  React.useEffect(() => {
    if (isOpen) {
      setCode('');
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    await onSubmit(code);
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
      <div className="modal-dialog">
        <form id="admin-security-step-up-form" className="modal-content" onSubmit={handleSubmit}>
          <div className="modal-header">
            <h5 className="modal-title">{t('securityStepUp.title')}</h5>
            <button
              type="button"
              className="btn-close"
              aria-label={t('common.cancel')}
              onClick={onCancel}
              disabled={isSubmitting}
            ></button>
          </div>
          <div className="modal-body">
            <p className="text-muted mb-3">{t('securityStepUp.message')}</p>
            {error ? <div className="alert alert-danger py-2">{error}</div> : null}
            <div className="mb-0">
              <label className="form-label" htmlFor="admin-security-step-up-code">
                {t('securityStepUp.code')}
              </label>
              <input
                id="admin-security-step-up-code"
                type="text"
                inputMode="numeric"
                autoComplete="one-time-code"
                className="form-control"
                value={code}
                onChange={(event) => setCode(event.target.value)}
                disabled={isSubmitting}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-default" onClick={onCancel} disabled={isSubmitting}>
              {t('common.cancel')}
            </button>
            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
              {isSubmitting ? t('securityStepUp.verifying') : t('securityStepUp.submit')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SecurityStepUpModal;
